import React, { Component } from 'react';
import {Tabs, Tab} from "react-bootstrap"

export default class form_tabbing extends Component {
    render() {
        return (
            <div>
                <div className="steps-step ste-steps">    
                    <Tabs defaultActiveKey="first" id="step-9" className="mb-3 parent-enviornment">
                        <Tab eventKey="third" title="SUB ADMINS">
                        </Tab>
                    </Tabs>
                </div>
            </div>
        )
    }
}